import React from "react";
import { Loader2 } from "lucide-react";

// Official Trading Flow Review (TFR) logo — white ring/wordmark on black.
// On the light theme, `invert` flips it to black-on-white so it stays crisp.
export function BrandMark({ className = "h-8 w-8", invert = false }) {
  return (
    <img
      src="/tfr-logo.png"
      alt="Trading Flow Review"
      className={`${className} object-contain select-none ${invert ? "[filter:invert(1)]" : ""}`}
      draggable={false}
      data-testid="brand-mark"
    />
  );
}

export function BrandLogo({ markClass = "h-9 w-9", showText = true, live = false, invert = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <span className="relative inline-flex">
        <BrandMark className={markClass} invert={invert} />
        {live && <span className="absolute top-0 right-0 h-2 w-2 rounded-full bg-cyan-500 live-dot-cyan" />}
      </span>
      {showText && (
        <span className="hidden sm:flex flex-col leading-none">
          <span className="font-display font-extrabold text-slate-900 tracking-[0.12em] text-sm">
            TRADING<span className="text-blue-600"> FLOW</span> REVIEW
          </span>
          <span className="font-mono text-[9px] text-slate-500 tracking-[0.25em] mt-0.5">INSTITUTIONAL FLOW ANALYTICS</span>
        </span>
      )}
    </div>
  );
}

export function BrandSplash({ label = "Loading market data…" }) {
  return (
    <div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#070A10] overflow-hidden"
      style={{ backgroundImage: "url(/brand-splash.jpg)", backgroundSize: "cover", backgroundPosition: "center" }}
      data-testid="brand-splash"
    >
      <div className="absolute inset-0 bg-[#070A10]/80" />
      <div className="relative flex flex-col items-center gap-6">
        <span className="relative inline-flex">
          <span className="absolute inset-0 blur-3xl bg-cyan-500/30 rounded-full animate-pulse" />
          <BrandMark className="h-28 w-28 relative" />
        </span>
        <div className="flex items-center gap-2 text-[11px] font-mono text-slate-400 tracking-wider">
          <Loader2 className="h-3.5 w-3.5 animate-spin text-cyan-400" /> {label}
        </div>
      </div>
    </div>
  );
}
